function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.35898 8.61523V10.5935C7.35898 10.9264 7.6368 11.181 8.00007 11.181C9.08995 11.181 9.9875 12.0037 9.9875 13.0026C9.9875 14.0015 9.08995 14.8241 8.00007 14.8241C6.91019 14.8241 6.01264 14.0015 6.01264 13.0026C6.01264 12.6696 5.73482 12.415 5.37155 12.415C5.00829 12.415 4.73047 12.6696 4.73047 13.0026C4.73047 14.6479 6.20501 15.9993 8.00011 15.9993C9.79521 15.9993 11.2697 14.6479 11.2697 13.0026C11.2697 11.5532 10.1371 10.3388 8.64123 10.0646V8.61523H7.35898V8.61523Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4576 8.71357C10.6926 8.71357 10.9063 8.59604 11.0132 8.41976L13.9195 3.64064C14.0691 3.38601 14.005 3.09221 13.7699 2.89636L10.8636 0.643936C10.7568 0.546013 10.6071 0.506836 10.4576 0.506836H5.54244C5.39286 0.506836 5.24327 0.565582 5.13639 0.643936L2.23006 2.8964C1.99498 3.07267 1.93089 3.38605 2.08047 3.64068L4.9868 8.4198C5.09365 8.61565 5.30737 8.71361 5.54244 8.71361H7.3589H8.6411H10.4576V8.71357Z"
});

function SvgHookBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHookBig);
export default __webpack_public_path__ + "static/media/hookBig.7c5b8059.svg";
export { ForwardRef as ReactComponent };